var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "testPaper" },
    [
      _c("Header"),
      _vm._v(" "),
      _vm.testPaperData
        ? _c("div", { staticClass: "container testPaperBox" }, [
            _c("h2", [_vm._v(_vm._s(_vm.testPaperData.testName))]),
            _vm._v(" "),
            _c("h3", { staticClass: "score" }, [
              _vm._v(
                _vm._s(
                  `共得分：${
                    _vm.testPaperData.totalScore
                      ? _vm.testPaperData.totalScore
                      : 0
                  }分`
                )
              ),
            ]),
            _vm._v(" "),
            _vm.testPaperData.singleChoiceQuestionNum
              ? _c("div", { staticClass: "singleQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `单选题（共 ${_vm.testPaperData.singleChoiceQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "singleQuestionsBox" },
                    _vm._l(
                      _vm.testPaperData.singleChoiceQuestions,
                      function (single, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "questions" },
                          [
                            single.checkStatus == "正确"
                              ? _c("i", { staticClass: "el-icon-check" })
                              : _c("i", { staticClass: "el-icon-close" }),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "questionsTitle" }, [
                                _c("span", [_vm._v(_vm._s(`${index + 1}.`))]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "title",
                                  domProps: {
                                    innerHTML: _vm._s(` ${single.title}`),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      `（得分：${
                                        single.getQuestionScore
                                          ? single.getQuestionScore
                                          : 0
                                      }分）`
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "singleOption" },
                                _vm._l(
                                  single.options,
                                  function (option, optionIndex) {
                                    return _c("span", {
                                      key: optionIndex,
                                      class: option.isSelect
                                        ? "colorCheck"
                                        : "",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          `${_vm.optionMap[optionIndex]}.${option.option}`
                                        ),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              single.checkStatus == "错误"
                                ? _c(
                                    "div",
                                    _vm._l(
                                      single.options,
                                      function (option, optionIndex) {
                                        return _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  option.id == single.optionId,
                                                expression:
                                                  "option.id == single.optionId",
                                              },
                                            ],
                                            key: optionIndex,
                                            staticClass: "successAnswer",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                `正确答案：${_vm.optionMap[optionIndex]}`
                                              )
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "analysis" }, [
                                _vm._v(
                                  _vm._s(`【解析】：${single.description}`)
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaperData.multipleChoiceQuestionNum
              ? _c("div", { staticClass: "multipleQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `多选题（共 ${_vm.testPaperData.multipleChoiceQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "multipleQuestionsBox" },
                    _vm._l(
                      _vm.testPaperData.multipleChoiceQuestions,
                      function (multiple, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "questions" },
                          [
                            multiple.checkStatus == "正确"
                              ? _c("i", { staticClass: "el-icon-check" })
                              : _c("i", { staticClass: "el-icon-close" }),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "questionsTitle" }, [
                                _c("span", [_vm._v(_vm._s(`${index + 1}.`))]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(`${multiple.title}`),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      `（得分：${
                                        multiple.getQuestionScore
                                          ? multiple.getQuestionScore
                                          : 0
                                      }分）`
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "multipleOption" },
                                _vm._l(
                                  multiple.options,
                                  function (option, optionIndex) {
                                    return _c("span", {
                                      key: optionIndex,
                                      class: option.isSelect
                                        ? "colorCheck"
                                        : "",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          `${_vm.optionMap[optionIndex]}.${option.option}`
                                        ),
                                      },
                                    })
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              multiple.checkStatus == "错误"
                                ? _c("span", { staticClass: "successAnswer" }, [
                                    _vm._v(
                                      _vm._s(
                                        `正确答案：${multiple.succeedOption.join(
                                          " "
                                        )}`
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "analysis" }, [
                                _vm._v(
                                  _vm._s(`【解析】：${multiple.description}`)
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaperData.gapFillingQuestionNum
              ? _c("div", { staticClass: "gapFillingQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `填空题（共 ${_vm.testPaperData.gapFillingQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "judgeQuestionsBox" },
                    _vm._l(
                      _vm.testPaperData.gapFillingQuestions,
                      function (gapFilling, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "questions" },
                          [
                            gapFilling.checkStatus == "正确"
                              ? _c("i", { staticClass: "el-icon-check" })
                              : _c("i", { staticClass: "el-icon-close" }),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "questionsTitle" }, [
                                _c("span", [_vm._v(_vm._s(`${index + 1}.`))]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(`${gapFilling.title}`),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      `（得分：${
                                        gapFilling.getQuestionScore
                                          ? gapFilling.getQuestionScore
                                          : 0
                                      }分）`
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "judgeOption" },
                                _vm._l(
                                  gapFilling.stuGapFilling,
                                  function (option, gapFillingIndex) {
                                    return _c(
                                      "span",
                                      { key: gapFillingIndex },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            `填空${
                                              gapFillingIndex + 1
                                            }：${option}`
                                          )
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                              _vm._v(" "),
                              gapFilling.checkStatus == "错误"
                                ? _c(
                                    "div",
                                    { staticClass: "judgeSuccessAnswer" },
                                    [
                                      _c("span", [_vm._v("正确答案：")]),
                                      _vm._v(" "),
                                      _vm._l(
                                        gapFilling.gapFilling,
                                        function (suitem, suIndex) {
                                          return _c("span", { key: suIndex }, [
                                            _vm._v(
                                              _vm._s(
                                                `填空${suIndex + 1}: ${
                                                  suitem[0]
                                                }`
                                              )
                                            ),
                                          ])
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "analysis" }, [
                                _vm._v(
                                  _vm._s(`【解析】：${gapFilling.description}`)
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaperData.judgeQuestionNum
              ? _c("div", { staticClass: "judgeQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `判断题（共 ${_vm.testPaperData.judgeQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "judgeQuestionsBox" },
                    _vm._l(
                      _vm.testPaperData.judgeQuestions,
                      function (judge, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "questions" },
                          [
                            judge.checkStatus == "正确"
                              ? _c("i", { staticClass: "el-icon-check" })
                              : _c("i", { staticClass: "el-icon-close" }),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "questionsTitle" }, [
                                _c("span", [_vm._v(_vm._s(`${index + 1}.`))]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(`${judge.title}`),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      `（得分：${
                                        judge.getQuestionScore
                                          ? judge.getQuestionScore
                                          : 0
                                      }分）`
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "judgeOption" }, [
                                _c("i", {
                                  staticClass: "el-icon-circle-check",
                                  class:
                                    judge.stuAnswer == "正确"
                                      ? "colorCheck"
                                      : "",
                                }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "el-icon-circle-close",
                                  class:
                                    judge.stuAnswer == "错误"
                                      ? "colorCheck"
                                      : "",
                                }),
                              ]),
                              _vm._v(" "),
                              judge.checkStatus == "错误"
                                ? _c("span", { staticClass: "successAnswer" }, [
                                    _vm._v("正确答案："),
                                    _c("i", {
                                      class:
                                        judge.answer == "正确"
                                          ? "el-icon-circle-check"
                                          : "el-icon-circle-close",
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "analysis" }, [
                                _vm._v(
                                  _vm._s(`【解析】：${judge.description}`)
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.testPaperData.comprehensiveQuestionNum
              ? _c("div", { staticClass: "comprehensiveQuestions" }, [
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        `问答题（共 ${_vm.testPaperData.comprehensiveQuestionNum} 道题）`
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "comprehensiveQuestionsBox" },
                    _vm._l(
                      _vm.testPaperData.comprehensiveQuestions,
                      function (comprehensive, index) {
                        return _c("div", { key: index }, [
                          _c("span", {
                            staticClass: "questionsBox",
                            domProps: {
                              innerHTML: _vm._s(
                                `${index + 1}. ${comprehensive.title}`
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "judgeOption" },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  autosize: { minRows: 10 },
                                  resize: "none",
                                  disabled: true,
                                },
                                model: {
                                  value: comprehensive.stuAnswer,
                                  callback: function ($$v) {
                                    _vm.$set(comprehensive, "stuAnswer", $$v)
                                  },
                                  expression: "comprehensive.stuAnswer",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("Foot"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/testPaper.vue?vue&type=template&id=4369d98c&scoped=true&
// module id = null
// module chunks = 